export default __webpack_public_path__ + "static/media/Jen_Amos_AHV_In_Moms_We_Trust.cdfa7d9f.jpg";